import { Truncate } from '@re-dev/react-truncate'

import { UserDocument } from '../lib/userDocuments.slice'
import { UserDocumentCategory } from '@/features/admin/user-document-categories/userDocumentCategories.slice'
import { getDocumentName } from '../lib/helpers'
import { Link, Table } from '@/ui'

interface FileNameCellProps {
  document: UserDocument
  category?: UserDocumentCategory
}

export const FileNameCell = ({ document, category }: FileNameCellProps) => {
  const documentName = getDocumentName(document, category)
  return (
    <Table.Cell>
      {document.signedUrl ? (
        <Link href={document.signedUrl} newPage>
          <Truncate width={200}>{documentName}</Truncate>
        </Link>
      ) : (
        documentName
      )}
    </Table.Cell>
  )
}
